var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn d-flex justify-content-center align-items-center",class:{
            'btn--with-icon':typeof _vm.icon !== 'undefined' && _vm.icon !== null
        },on:{"click":function($event){_vm.$emit('buttonClick')}}},[(typeof _vm.icon !== 'undefined' && _vm.icon !== null)?_c('i',{staticClass:"material-icons",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "),_vm._t("content")],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30c7b479","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/Shared/Resources/Assets/js/components/buttons/Buttons.vue
// module id = +mJ0
// module chunks = 0